import { render, staticRenderFns } from "./PointMallEditNFTDialog.vue?vue&type=template&id=f4294542&scoped=true&"
import script from "./PointMallEditNFTDialog.vue?vue&type=script&lang=js&"
export * from "./PointMallEditNFTDialog.vue?vue&type=script&lang=js&"
import style0 from "./PointMallEditNFTDialog.vue?vue&type=style&index=0&id=f4294542&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4294542",
  null
  
)

export default component.exports